import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { FIELD_TYPE_TEXT } from '../../../utils/CONSTANTS.js';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import Input from '../../../components/Input.js';
import { getNextStepKey, getNextStepPosition } from '../../../services/models/dialog.js';
import { jsx } from '@emotion/react';
var _excluded = ["name", "type", "className", "placeholder", "onKeyDown", "stepKey", "lineKey", "unit"];
var Default = function Default(_ref) {
  var name = _ref.name,
    type = _ref.type;
  _ref.className;
  var placeholder = _ref.placeholder,
    _onKeyDown = _ref.onKeyDown,
    stepKey = _ref.stepKey,
    lineKey = _ref.lineKey,
    unit = _ref.unit,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useField = useField(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var formikContext = useFormikContext();
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    currentStep = _useContext2.currentStep,
    setCurrentStep = _useContext2.setCurrentStep,
    currentLine = _useContext2.currentLine;
  return jsx(Fragment, null, jsx(Input, _extends({}, field, {
    type: type,
    isInvalid: Boolean(meta.touched && meta.error),
    textAlign: "center",
    width: "100%",
    size: "lg",
    unit: unit,
    placeholder: placeholder,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        helpers.setTouched(true);
        helpers.setValue(event.target.value);
        formikContext.validateForm();
        event.preventDefault();

        // TODO: Apparently, even with the call to validateForm, formik's
        //   internal state (meta) hasn't gotten the info yet that a field
        //   has an error at this point, so we manually at least check for
        //   non-empty. Optimally, this should work with formik's
        //   validation.
        if (meta.value.length) {
          var nextStepKey = getNextStepKey(data, currentLine, currentStep);

          // If there is no next step key, submit the form.
          if (!nextStepKey) {
            var _window;
            // Track user progress (last Step; Next is "Kontaktformular").
            (_window = window) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 || _window.track("".concat(currentLine, "-clickto_step_Kontaktformular"), {
              label: 'Enter',
              category: 'formwizard'
            });
            formikContext.submitForm();
            // Else go to next step.
          } else {
            var _window2;
            var nextStepPosition = getNextStepPosition(data, lineKey, stepKey);
            // Track user progress
            (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.analytics) === null || _window2 === void 0 || _window2.track("".concat(lineKey, "-clickto_step").concat(nextStepPosition, "_").concat(nextStepKey), {
              label: event.target.value,
              category: 'formwizard'
            });
            setCurrentStep(nextStepKey);
          }
        }
      }
      if (_onKeyDown) {
        _onKeyDown(event);
      }
    }
  }, props)));
};
Default.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  stepKey: PropTypes.string.isRequired,
  lineKey: PropTypes.string.isRequired,
  unit: PropTypes.string
};
Default.defaultProps = {
  type: FIELD_TYPE_TEXT,
  placeholder: null,
  className: '',
  onKeyDown: null,
  unit: null
};
export { Default as default };